/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyEventType } from '../../models/calendly-event-type';
import { CreateCalendlyEventTypeRequest } from '../../models/create-calendly-event-type-request';

export interface CreateCalendlyEventType$Params {
      body: CreateCalendlyEventTypeRequest
}

export function createCalendlyEventType(http: HttpClient, rootUrl: string, params: CreateCalendlyEventType$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyEventType>> {
  const rb = new RequestBuilder(rootUrl, createCalendlyEventType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyEventType>;
    })
  );
}

createCalendlyEventType.PATH = '/v1/api/ui/calendly-demo/event-types';
